'use client';

import classNames from 'classnames';
import { LandingServices } from '@sapientpro/sapientpro-data-models/types/components/landing-page';
import styles from './Stores.module.scss';
import AnimatedTitle from '../../../components/AnimatedTitle';
import StoreCard from './StoreCard';

const Stores = ({
  data,
}: {
  data: LandingServices;
}) => (
  <section className={classNames(styles.stores, 'container')}>
    <h2 className={classNames(styles.stores__title, 'header2')}>
      <AnimatedTitle title={data.title} />
    </h2>
    <div className={styles.stores__content}>
      {!!data?.service1List && (
      <StoreCard
        video={{ light: data.service1Video, dark: data.service1VideoDark ?? data.service1Video }}
        title={data.service1Title}
        description={data.service1Description}
        items={data?.service1List.map((item) => ({
          title: item.title,
          description: item.description,
          icon: { light: item.image, dark: item.darkImage ?? item.image },
        }))}
      />
      )}
      {!!data.service2List && (
      <StoreCard
        video={{ light: data.service2Video, dark: data.service2VideoDark ?? data.service2Video }}
        title={data.service2Title}
        description={data.service2Description}
        items={data.service2List?.map((item) => ({
          title: item.title,
          description: item.description,
          icon: { light: item.image, dark: item.darkImage ?? item.image },
        }))}
        removeLeftBorder
      />
      )}
    </div>
  </section>
);

export default Stores;
